module.exports = __webpack_public_path__ + "img/bj-icon.426b5e53.png";